module.exports = __webpack_public_path__ + "static/media/Keytel.abf15776.ico";